export function createAppearanceDialogController({
  state,
  panel,
  closeButton,
  titleSelector,
  titleKey,
  closeLabelKey,
  lastFocusKey,
  menuToggleButton,
  syncModalLock,
  setMenuOpen,
  closeNodeMenus,
  t,
}) {
  function setOpen(isOpen) {
    panel.hidden = !isOpen;
    syncModalLock();

    if (isOpen) {
      const titleEl = panel.querySelector(titleSelector);
      if (titleEl) {
        titleEl.textContent = t(titleKey);
      }
      if (closeButton) {
        closeButton.setAttribute('aria-label', t(closeLabelKey));
      }

      state[lastFocusKey] = document.activeElement instanceof HTMLElement ? document.activeElement : null;
      setMenuOpen(false);
      closeNodeMenus();
      closeButton?.focus();
      return;
    }

    if (state[lastFocusKey] && state[lastFocusKey].offsetParent !== null) {
      state[lastFocusKey].focus();
    } else {
      menuToggleButton.focus();
    }
    state[lastFocusKey] = null;
  }

  function open() {
    setOpen(true);
  }

  function close() {
    setOpen(false);
  }

  return { setOpen, open, close };
}
